import gql from 'graphql-tag';

export const createAdminUserMutation = gql`
  mutation CreateAdminUser($tenant: String!, $email: String!) {
    createAdminUser(tenant: $tenant, email: $email)
  }
`;